// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1_sOU","tab":"FE0-9","tab_active":"XDiw4"};